export function not(predicate) {
    return (value) => !predicate(value);
}
export function equals(a) {
    return (b) => a === b;
}
export function falsy(obj) {
    return !obj;
}
